<div class="header-container">
  <!-- Hamburger menu (solo mobile) -->
  <button mat-icon-button
          class="hamburger-btn"
          (click)="toggleSidebar()"
          aria-label="Menu">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="demo-info-header" *ngIf="demoDaysLeft() !== null">
    Il periodo di prova scade tra {{ demoDaysLeft() }} giorni
  </div>

  <!-- Azioni a destra -->
  <div class="actions">
    <ng-container *ngIf="!appReady">
      <ngx-skeleton-loader appearance="circle" [theme]="{ height: '36px', width: '36px', marginBottom: '0' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader appearance="circle" [theme]="{ height: '36px', width: '36px', marginBottom: '0' }"></ngx-skeleton-loader>
    </ng-container>

    <ng-container *ngIf="appReady">
      <!-- Icona search
      <button mat-icon-button aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
-->
      <!-- Icona user con cerchio azzurro -->
      <button mat-icon-button
              class="user-btn"
              [matMenuTriggerFor]="profileMenu"
              aria-label="Profile">
        <span *ngIf="initials(); else personIcon" class="user-initials">{{ initials() }}</span>
        <ng-template #personIcon><mat-icon>person_outline</mat-icon></ng-template>
      </button>

      <!-- Menu dropdown -->
      <mat-menu #profileMenu="matMenu">
        <div class="theme-menu-row" (click)="$event.stopPropagation()">
          <div class="profile-text">
            <div class="profile-name">{{ denominazione() }}</div>
            <div class="profile-email">{{ email() }}</div>
          </div>
          <div class="theme-row">
          <div class="theme-label">
            <mat-icon>{{ darkMode() ? 'dark_mode' : 'light_mode' }}</mat-icon>
            <span>{{ darkMode() ? 'Tema scuro' : 'Tema chiaro' }}</span>
          </div>
          <p-inputSwitch
            styleClass="theme-switch"
            [ngModel]="darkMode()"
            (ngModelChange)="setDarkMode($event)"
            (click)="$event.stopPropagation()"
            ariaLabel="Attiva tema scuro"
          ></p-inputSwitch>
        </div>
        </div>

        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </ng-container>
  </div>
</div>
